import { createTheme, makeStyles, MuiThemeProvider, TextField, useTheme } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { Autocomplete } from '@material-ui/lab';
import { toCssValue } from '@topconagriculture/theme';
import * as React from 'react';
import { Checkbox } from '../Checkbox';
import { Text } from '../../Text';
const icon = React.createElement(CheckBoxOutlineBlankIcon, { fontSize: "small" });
const checkedIcon = React.createElement(CheckBoxIcon, { fontSize: "small" });
const useStyles = makeStyles((theme) => ({
    textInput: {
        color: (props) => (props.dark ? theme.color.font.dark : theme.color.font.light),
    },
    selectedTag: {
        marginRight: 8,
        display: 'block',
        '&::after': {
            content: '-',
        },
        '&:last-child': {
            '&::after': {
                content: '',
            },
        },
    },
}));
const getMuiTheme = (theme, dark) => {
    const fontColor = dark ? theme.color.font.dark : theme.color.font.light;
    return createTheme({
        overrides: {
            MuiInput: {
                underline: {
                    '&:before': {
                        borderBottom: `1px solid ${fontColor} !important`,
                    },
                },
            },
            MuiInputLabel: {
                formControl: { color: `${fontColor} !important`, transform: `translate(0, 10px) scale(1)` },
                shrink: { transform: 'translate(0, 1px) scale(0.7)' },
            },
            MuiIconButton: {
                root: { color: fontColor },
            },
            MuiAutocomplete: {
                input: {
                    padding: '4px 0 !important',
                },
                inputRoot: {
                    marginTop: '0px !important',
                    color: fontColor,
                    fontSize: 12,
                    padding: toCssValue([11, 0, 2]),
                },
            },
        },
    });
};
const MultipleAutocompleteSelect = React.forwardRef((props, ref) => {
    const { label, options, values, setValues, testId = 'MultipleAutocompleteSelect', dark } = props;
    const classes = useStyles(props);
    const theme = useTheme();
    const onSetValues = (_, values) => {
        setValues(values);
    };
    return (React.createElement(MuiThemeProvider, { theme: getMuiTheme(theme, dark) },
        React.createElement(Autocomplete, { disableCloseOnSelect: true, "data-testid": `${testId}`, value: values, onChange: onSetValues, limitTags: 3, multiple: true, ref: ref, options: options, renderOption: (option, { selected }) => (React.createElement(React.Fragment, null,
                React.createElement(Checkbox, { "data-testid": `${testId}-ckeckbox`, icon: icon, checkedIcon: checkedIcon, style: { marginRight: 8 }, checked: selected }),
                option)), renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { "data-testid": `${testId}-input`, classes: { root: classes.textInput }, style: { width: '100%' }, label: label }))), renderTags: (value) => value.map((m) => (React.createElement(Text, { "data-testid": `${testId}-${m}`, key: m, className: classes.selectedTag }, m))) })));
});
export default MultipleAutocompleteSelect;
//# sourceMappingURL=MultipleAutocompleteSelect.js.map